import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../headers/DashboardHeader";

export default function TermsUse() {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    navigate("/dashboard");
  };

  return (
    <>
      <div className="header-container">
        <DashboardHeader />
      </div>
      <div
        className="container"
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "20px",
          overflowY: "scroll",
          maxHeight: "calc(100vh - 90px)",
          marginBottom: "20px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <div
          className="card"
          style={{
            padding: "2rem",
            boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
          }}
        >
          <h2 className="text-center primary-color">Terms of Use</h2>
          <h3 className="text-center mb-4">
            Little Haiti Global Project Portal
          </h3>
          <h4 className="mb-3">Welcome!</h4>
          <p>
            We are <strong>Little Haiti Global Inc.</strong> ({" "}
            <strong>“ LHG,” “we,” “us” or “our”</strong>), and through the{" "}
            Little Haiti Global Project Portal (the <strong>“Portal”</strong>),
            we offer a secure, online platform designed to manage applications,
            information, and communications relating to the Little Haiti Global
            relocation and investment initiative (the <strong>“Program”</strong>
            ).
          </p>
          <p>
            The Portal comprises various features, content, tools, applications,
            and services (collectively, the <strong>“Services”</strong>) that
            enable and facilitate the submission, processing, and management of
            relocation and investment applications, payments, and related
            communications.
          </p>
          <p>
            These Terms of Use (the <strong>“Terms of Use”</strong> or
            <strong>“Terms”</strong>) govern your visit, access to, and use of
            the Portal and the Services and are binding upon you immediately
            when you access or use the Portal. Any time you access, browse, or
            otherwise use the Portal or the Services, you agree to be bound by
            and are subject to these Terms, as amended from time to time.{" "}
            <strong>Please read them carefully.</strong>
          </p>
          <p>
            We may, at our sole discretion, modify or revise these Terms at any
            time without prior notice. Your continued use of the Portal
            following any such changes constitutes your acceptance of the
            revised Terms.
          </p>
          <p>
            For clarity, these Terms apply to (i) all individual persons,
            companies, organizations or other entities, applicants, investors,
            representatives, and any authorized users accessing the Portal, and
            (ii) any employees, affiliates, or agents operating under or on
            behalf of such users. In these Terms, <strong>“you”</strong> or
            <strong> “your”</strong> or <strong>“User”</strong> or
            <strong> “Users”</strong> refers to each such person or entity
            described above, and together with LHG, each is a
            <strong> “Party”</strong> and collectively the
            <strong> “Parties”</strong>.
          </p>
          {/* Section 1 - User Accounts */}
          <h4 className="mt-4">1. User Accounts</h4>
          <p>
            To actively use and benefit from the Services, you must sign up and
            create an account (each, an <strong>“Account”</strong>). You may be
            prompted to provide certain information depending on whether you are
            an applicant, investor, authorized representative, or other
            participant in the Program.
          </p>

          <p className="mb-1">You are solely responsible for:</p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>
              (i) maintaining the confidentiality of your login credentials (
              <strong> “Login Information”</strong> );
            </li>
            <li>
              (ii) providing accurate, complete, and truthful information at all
              times; and
            </li>
            <li>
              (iii) immediately notifying LHG of any unauthorized use or
              suspected compromise of your Account.
            </li>
          </ul>

          <p>
            Further to the foregoing and to reiterate, by creating an Account,
            accessing the Portal, or using any of the Services, you: (i){" "}
            <strong>acknowledge</strong> that you have read, understood, and
            agreed to be bound by these Terms; (ii) <strong>agree</strong> to
            comply with them in their entirety; and (iii){" "}
            <strong>expressly consent</strong> to receive and engage in all
            communications from LHG electronically, including via the Portal’s
            secure messaging system, email, and SMS, for all matters relating to
            the Program.
          </p>

          <p>
            We reserve the right to <strong>suspend or terminate</strong> any
            Account, or remove any content we deem, in our sole discretion, to
            be illegal, fraudulent, defamatory, obscene, discriminatory, or
            otherwise inappropriate.
          </p>

          {/* Section 2 - Scope of Services */}
          <h4 className=" mt-4">2. Scope of Services</h4>
          <p>
            The <strong>LHG Portal</strong> allows eligible individuals to:
          </p>

          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>(i) Submit relocation and investment applications;</li>
            <li>(ii) Track case progress through a personalized dashboard;</li>
            <li>(iii) Pay required fees and investment contributions;</li>
            <li>(iv) Submit and receive official communications;</li>
            <li>(v) Access digital forms, updates, and advisories;</li>
            <li>(vi) Request technical support or assistance; and</li>
            <li>
              (vii) Receive notifications regarding eligibility, probation, and
              community integration.
            </li>
          </ul>

          <p>
            LHG may add, remove, or modify Services at any time in its sole
            discretion. Continued use following any changes constitutes
            acceptance of such changes.
          </p>

          {/* Section 3 - Eligibility and Age Requirements */}
          <h4 className=" mt-4">
            3. Eligibility and Age Requirements
          </h4>
          <p>
            To create an Account, access the Portal, or use the Services
            independently, you must be at least eighteen (18) years of age or
            the legal age of majority in your jurisdiction, whichever is higher.
          </p>
          <p>
            If you are under the age of majority in your jurisdiction but meet
            the minimum digital consent age established by the data protection
            laws of your country of residence, which is thirteen (13) years of
            age in the United States under the{" "}
            <strong>Children’s Online Privacy Protection Act (COPPA)</strong>,
            and may be between thirteen (13) and sixteen (16) years of age under
            applicable
            <strong> European Union or United Kingdom law</strong>, you may only
            use the Portal and the Services if your Account is created and
            actively managed by your parent or legal guardian. That parent or
            legal guardian must have lawful authority to act on your behalf and
            must consent to the collection, use, and disclosure of your personal
            information in accordance with these Terms and LHG’s Privacy
            Policies. Full control of the Account will transfer to you upon
            reaching the age of majority.
          </p>
          <p>
            The Portal and the Services are not directed to children under the
            minimum digital consent age for their jurisdiction, and LHG does not
            knowingly collect personal information from such children without
            verifiable parental consent, in compliance with{" "}
            <strong>COPPA</strong>, the
            <strong> EU General Data Protection Regulation (GDPR)</strong>, the
            <strong> UK Data Protection Act 2018</strong>, and equivalent laws
            in other jurisdictions. If LHG becomes aware that it has collected
            personal information from a child below the applicable age threshold
            without the required consent, it will promptly delete such
            information.
          </p>

          {/* Section 4 - User Responsibilities */}
          <h4 className=" mt-4">4. User Responsibilities</h4>
          <p className="mb-1">Users agree to:</p>

          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>
              (i) Use the Portal solely for lawful purposes and for authorized
              participation in the LHG Program, in full compliance with these
              Terms and all applicable laws and regulations;
            </li>
            <li>
              (ii) Maintain the confidentiality and security of their Login
              Information and take reasonable measures to prevent unauthorized
              access to their Account;
            </li>
            <li>
              (iii) Provide and maintain accurate, complete, and truthful
              information during the application process and in all subsequent
              updates, and promptly correct any information that becomes
              outdated or incorrect;
            </li>
            <li>
              (iv) Refrain from sharing their Account or Login Information with
              any unauthorized person, and from impersonating, misrepresenting,
              or falsely identifying themselves as another individual, company,
              or entity; and
            </li>
            <li>
              (v) Promptly report to LHG any unauthorized access, suspicious
              activity, or actual or suspected data compromise relating to their
              Account or use of the Portal.
            </li>
          </ul>

          {/* Section 5 - Data Privacy and Security */}
          <h4 className=" mt-4">5. Data Privacy and Security</h4>
          <p>
            LHG is committed to safeguarding User data in accordance with our
            Privacy Policies, which are incorporated herein by this reference.
            All information provided through the Portal is protected in
            accordance with the data privacy policies adopted by LHG, and
            personally identifiable information will not be sold or shared
            except as permitted under those policies or as permitted or required
            by law.
          </p>

          <p className="mb-1">Users agree to:</p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>
              (i) Provide and maintain accurate contact information that remains
              active throughout their participation in the Program;
            </li>
            <li>
              (ii) Accept communications from LHG via email, SMS, and secure
              Portal messaging; and
            </li>
            <li>
              (iii) Cooperate fully with any identity verification protocols,
              including background checks and the provision of formal compliance
              documentation, when required by LHG.
            </li>
          </ul>

          <p>
            LHG may, at any time and in its sole discretion, conduct background
            checks or request formal compliance documentation to verify a User’s
            identity, eligibility, or continued participation in the Program.
          </p>

          {/* Section 6 - Prohibited Conduct */}
          <h4 className=" mt-4">6. Prohibited Conduct</h4>
          <p className="mb-1">Users shall not:</p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>
              (i) Access or attempt to access any data, systems, or areas of the
              Portal without proper authorization;
            </li>
            <li>(ii) Misrepresent their identity, status, or authority;</li>
            <li>
              (iii) Submit, post, or transmit any false, misleading, or
              fraudulent information;
            </li>
            <li>
              (iv) Share, disclose, or otherwise allow unauthorized persons to
              use their Portal access credentials;
            </li>
            <li>
              (v) Use any automated tools, scripts, bots, or similar
              technologies to extract, harvest, or manipulate data from the
              Portal; or
            </li>
            <li>
              (vi) Bypass, disable, or otherwise interfere with the Portal’s
              security protocols or the proper operation of the platform.
            </li>
          </ul>

          <p>
            Any violation of this section may result in the immediate{" "}
            <strong>suspension or permanent termination </strong>
            of the User’s Account, forfeiture of Program participation, and
            potential legal action.
          </p>
          {/* Section 7 - International Data Privacy and Cross-Border Transfers */}
          <h4 className=" mt-4">
            7. International Data Privacy and Cross-Border Transfers
          </h4>
          <p>
            LHG processes personal information in accordance with its Privacy
            Policies and applicable data protection laws, which may include,
            depending on your location, the
            <strong>
              {" "}
              European Union and United Kingdom General Data Protection
              Regulation (GDPR)
            </strong>
            , the <strong>California Consumer Privacy Act (CCPA)</strong> as
            amended by the
            <strong> California Privacy Rights Act (CPRA)</strong>, the
            <strong>
              {" "}
              Personal Information Protection and Electronic Documents Act
              (PIPEDA)
            </strong>{" "}
            of Canada, and other similar laws.
          </p>
          <p>
            By using the Portal and the Services, you acknowledge and agree that
            your personal information may be collected, stored, processed, and
            transferred to servers and systems located in the United States and
            in other countries where privacy laws may not provide the same level
            of protection as those in your jurisdiction. Where required by
            applicable law, LHG will implement appropriate safeguards, such as
            standard contractual clauses or other lawful transfer mechanisms, to
            ensure that your personal information is protected.
          </p>
          <p>
            If you are located in a jurisdiction that grants you specific
            privacy rights, you may have the right to access, correct, delete,
            or restrict the processing of your personal information, or to
            object to certain processing activities. Requests to exercise such
            rights should be submitted to
            <a href="mailto:privacy@littlehaitiglobal.com">
              {" "}
              privacy@littlehaitiglobal.com
            </a>
            . LHG will respond to such requests in accordance with applicable
            law.
          </p>

          {/* Section 8 - Security Measures */}
          <h4 className=" mt-4">8. Security Measures</h4>
          <p>
            LHG implements and maintains commercially reasonable administrative,
            technical, and physical safeguards designed to protect the
            confidentiality, integrity, and availability of the Portal, the
            Services, and any personal information we collect. Such measures may
            include, without limitation, encryption of data in transit and at
            rest, access controls, intrusion detection systems, firewalls,
            regular security testing, and employee training on data protection.
          </p>
          <p>
            While LHG takes reasonable steps to safeguard your information, no
            system or transmission of data over the Internet can be guaranteed
            to be 100% secure. You acknowledge and agree that you are
            responsible for implementing appropriate security measures on your
            own devices and networks, including maintaining up-to-date antivirus
            software and securing your Account credentials.
          </p>
          <p>
            You agree to promptly notify LHG at{" "}
            <a href="mailto:security@littlehaitiglobal.com">
              security@littlehaitiglobal.com
            </a>{" "}
            if you become aware of any actual or suspected unauthorized access
            to your Account, the Portal, or the Services, or of any other actual
            or suspected breach of security. LHG will investigate such reports
            and take actions it deems appropriate in accordance with applicable
            law.
          </p>
          {/* Section 9 - Payments, Currency, Refund and Chargebacks */}
          <h4 className=" mt-4">
            9. Payments, Currency, Refund and Chargebacks
          </h4>

          {/* Subsection A - Payments and Currency */}
          <p>
            <strong>A. Payments and Currency</strong>
          </p>
          <p>
            All fees, contributions, or other amounts payable in connection with
            the Portal or the Services must be paid in the currency specified by
            LHG at the time of payment, unless otherwise agreed in writing. You
            are responsible for any applicable currency conversion fees, bank
            charges, wire transfer fees, credit card processing fees, and any
            applicable taxes, duties, or other governmental charges.
          </p>
          <p>
            All payments must be made using payment methods approved by LHG. By
            providing payment information, you represent and warrant that you
            are authorized to use the chosen payment method and authorize LHG or
            its payment processor to charge the full amount to that method,
            including any recurring charges where applicable.
          </p>

          {/* Subsection B - Refunds */}
          <p>
            <strong>B. Refunds</strong>
          </p>
          <p>
            Except where otherwise required by law or expressly stated by LHG in
            writing, all fees and payments are <strong>non-refundable</strong>{" "}
            once processed. If a refund is issued, it will be made in the
            original currency of payment, and you acknowledge that exchange rate
            fluctuations or fees imposed by your bank or payment provider may
            affect the amount you ultimately receive.
          </p>
          <p>
            You agree that all payments are subject to applicable{" "}
            <strong>anti-money laundering</strong>,
            <strong> counter-terrorist financing (CTF)</strong>, and{" "}
            <strong>sanctions compliance</strong> screening, and LHG may
            withhold, delay, or refuse to process a payment if it reasonably
            determines that processing would violate applicable laws or expose
            LHG to regulatory or reputational risk.
          </p>

          {/* Subsection C - Chargebacks */}
          <p>
            <strong>C. Chargebacks</strong>
          </p>
          <p>
            You agree not to initiate any chargeback or payment dispute with
            your credit card issuer, bank, or payment provider for any amounts
            properly charged by LHG in accordance with these Terms. If you
            believe a charge was made in error, you must contact LHG promptly at
            <a href="mailto:billing@littlehaitiglobal.com">
              {" "}
              billing@littlehaitiglobal.com
            </a>{" "}
            so that we may investigate and, if appropriate, issue a refund
            directly.
          </p>
          <p>
            If you initiate a chargeback in violation of this section, LHG may{" "}
            <strong>suspend or terminate</strong>
            your Account, recover any amounts refunded through the chargeback
            process, and recover from you any fees, costs, or expenses incurred
            in connection with the chargeback, including reasonable attorneys’
            fees.
          </p>

          {/* Section 10 - Intellectual Property; Infringement */}
          <h4 className=" mt-4">
            10. Intellectual Property; Infringement
          </h4>

          {/* Subsection A - Intellectual Property */}
          <p>
            <strong>A. Intellectual Property</strong>
          </p>
          <p>
            Except as provided in 9C below, all content, designs, text,
            graphics, images, video, audio, software, source code, object code,
            databases, and all other materials or technology comprising or used
            in connection with the Portal and the Services, together with all
            associated copyrights, trademarks, service marks, trade names, trade
            dress, patents, trade secrets, and other intellectual property
            rights (collectively, the “<strong>Intellectual Property</strong>”),
            are and shall remain the sole and exclusive property of LHG or its
            licensors.
          </p>
          <p>
            Except as expressly permitted in writing by LHG, you shall not,
            directly or indirectly:
          </p>

          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>
              (i) Copy, reproduce, modify, adapt, translate, create derivative
              works of, publicly display, perform, or distribute any portion of
              the Intellectual Property;
            </li>
            <li>
              (ii) Sublicense, sell, rent, lease, loan, or otherwise transfer
              any rights in the Intellectual Property;
            </li>
            <li>
              (iii) Remove, obscure, or alter any proprietary notices, legends,
              or labels on or within the Intellectual Property; or
            </li>
            <li>
              (iv) Use the Intellectual Property in any manner that infringes,
              misappropriates, or otherwise violates LHG’s rights or those of
              its licensors.
            </li>
          </ul>

          <p>
            All rights not expressly granted to you under these Terms are
            reserved by LHG and its licensors.
          </p>

          {/* Subsection B - Infringement */}
          <p>
            <strong>B. Infringement</strong>
          </p>
          <p>
            Upon becoming aware of any infringement of our or any of your or
            other Users’ or any third party’s intellectual property on the LHG
            Portal, please contact us as soon as possible and we will make every
            effort to remedy the situation.
          </p>
          <p>
            Notice of any infringement should be sent to our intellectual
            property agent at the following e-mail address:{" "}
            <strong>support@littlehaitiglobal.com</strong>
          </p>

          {/* Subsection C - User Content and License Grant */}
          <p>
            <strong>C. User Content and License Grant</strong>
          </p>
          <p>
            You retain all ownership rights in any data, documents, images,
            text, audio, video, or other materials that you submit, upload,
            post, transmit, or otherwise provide through the Portal or the
            Services (“<strong>User Content</strong>”). By providing User
            Content, you grant LHG a worldwide, non-exclusive, royalty-free,
            fully paid-up, transferable, sublicensable license to use, host,
            store, reproduce, modify, adapt, translate, create derivative works
            from, display, perform, distribute, and otherwise process your User
            Content solely for the purposes of operating, providing, improving,
            and promoting the Portal, the Services, and the Program.
          </p>
          <p>
            You represent and warrant that you have all necessary rights,
            licenses, consents, and permissions to provide the User Content and
            to grant the rights described in this Section, and that your User
            Content does not infringe, misappropriate, or violate the
            intellectual property, privacy, or other rights of any third party.
          </p>
          <p>
            LHG has no obligation to monitor User Content but reserves the right
            to review, remove, or disable access to any User Content at its sole
            discretion and without notice, if it reasonably determines that such
            content violates these Terms, applicable law, or the rights of any
            third party.
          </p>
          {/* Section 11 - Suspension and Termination */}
          <h4 className=" mt-4">11. Suspension and Termination</h4>
          <p>
            LHG may, at any time and in its sole and absolute discretion,
            suspend, restrict, or terminate your Account, your access to the
            Portal, or your use of the Services, with or without prior notice,
            for any reason or no reason, including but not limited to:
          </p>

          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>
              (i) Any actual, alleged, or suspected breach of these Terms;
            </li>
            <li>
              (ii) Failure to comply with verification, documentation, or
              payment obligations;
            </li>
            <li>
              (iii) Provision of false, misleading, or incomplete information;
            </li>
            <li>
              (iv) Evidence or suspicion of fraudulent, harmful, or unauthorized
              activity; or
            </li>
            <li>
              (v) Conduct that, in LHG’s judgment, may damage, disrupt, or
              otherwise adversely affect the Portal, the Services, other Users,
              or LHG’s operations or reputation.
            </li>
          </ul>

          <p>
            Reinstatement of any suspended or terminated Account shall be at
            LHG’s sole discretion and may be subject to additional conditions,
            including verification procedures, payment of outstanding amounts,
            and execution of undertakings to comply with these Terms.
          </p>

          {/* Section 12 - Third-Party Links */}
          <h4 className=" mt-4">12. Third-Party Links</h4>
          <p>
            The Portal may contain links or references to third-party websites,
            applications, or other online resources (collectively, “
            <strong>Third-Party Sites</strong>”) that are provided solely for
            your convenience or informational purposes. LHG does not control,
            endorse, sponsor, or assume any responsibility for the content,
            products, services, policies, or practices of any Third-Party Site,
            including without limitation their privacy policies, terms of use,
            or security measures.
          </p>
          <p>
            Accessing any Third-Party Site is done at your own risk, and you
            acknowledge and agree that LHG shall have no liability arising from
            your use of, or reliance on, any content, goods, or services made
            available through such sites. Users are strongly encouraged to
            review the applicable terms and conditions, privacy policies, and
            practices of any Third-Party Site before engaging with, providing
            information to, or conducting transactions through them.
          </p>

          {/* Section 13 - Force Majeure */}
          <h4 className=" mt-4">13. Force Majeure</h4>
          <p>
            LHG shall not be liable or responsible to you, nor be deemed to have
            defaulted or breached these Terms, for any failure or delay in
            performance to the extent such failure or delay is caused by or
            results from acts or circumstances beyond LHG’s reasonable control,
            including, without limitation, acts of God, flood, fire, earthquake,
            explosion, governmental actions, war, invasion or hostilities
            (whether war is declared or not), terrorist threats or acts, riot or
            other civil unrest, national or regional emergency, epidemic,
            pandemic, public health emergency, strikes, labor stoppages or
            slowdowns, or other industrial disturbances, shortage of adequate
            power, telecommunications, or transportation facilities,
            cyberattacks, or other events beyond LHG’s control.
          </p>
          <p>
            In such cases, LHG’s obligations will be suspended for the duration
            of the delay, and LHG will use commercially reasonable efforts to
            resume performance as soon as practicable.
          </p>
          {/* Section 14 - Disclaimer of Warranty */}
          <h4 className=" mt-4">14. Disclaimer of Warranty</h4>
          <p style={{ textTransform: "uppercase" }}>
            Except as expressly set forth herein (and except as may be required
            by law), LHG expressly disclaims all representations and warranties,
            whether express, statutory, or implied, written or oral, in
            connection with the Services and these Terms of Use, including,
            without limitation, any implied warranties of merchantability,
            fitness for a particular purpose, title, or non-infringement. All
            materials and services provided through the Portal are provided “as
            is” and “with all faults,” and your use is at your own risk.
          </p>

          {/* Section 15 - Limitation of Liability */}
          <h4 className=" mt-4">15. Limitation of Liability</h4>
          <p style={{ textTransform: "uppercase" }}>
            To the maximum extent permitted by applicable law, in no event,
            whether in contract, warranty, tort (including negligence), strict
            liability or otherwise, will LHG be liable to any user for any lost
            profits or returns, lost savings, lost earnings, lost investments,
            lost subscription fees, or any special, incidental, exemplary,
            consequential, punitive, or indirect damages, arising out of or
            relating to:
          </p>

          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>
              (i) The User’s use or inability to use the Portal or the Services;
            </li>
            <li>(ii) The provision or non-provision of the Services;</li>
            <li>
              (iii) Any User Content provided through the Portal by LHG or other
              Users; or
            </li>
            <li>
              (iv) Any breach of these Terms of Use, even if LHG has been
              advised of the possibility of such damages.
            </li>
          </ul>

          {/* Section 16 - Indemnification */}
          <h4 className=" mt-4">16. Indemnification</h4>
          <p>
            In consideration of being bound by and subject to these Terms, and
            in addition to all other rights and remedies available at law or in
            equity, you agree to defend, indemnify, and hold harmless LHG, its
            officers, directors, shareholders, members, partners, affiliates,
            subsidiaries, employees, agents, representatives, successors, and
            permitted assigns (collectively, the “<strong>Indemnitees</strong>”)
            from and against any and all actions, causes of action, claims,
            suits, losses (including diminution in value and consequential
            damages), costs, penalties, fees, liabilities, damages, and expenses
            (including reasonable attorneys’ fees and disbursements, interest,
            and penalties), whether or not any Indemnitee is a party to the
            proceeding, arising out of or relating to:
          </p>

          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>(i) Your breach of these Terms of Use;</li>
            <li>(ii) Your misuse of the Portal or the Services; or</li>
            <li>
              (iii) Your violation of applicable laws or third party rights.
            </li>
          </ul>

          <p>
            To the extent the foregoing indemnification obligation may be
            unenforceable under applicable law, you shall make the maximum
            contribution permissible to the payment and satisfaction of such
            obligations.
          </p>

          {/* Section 17 - Modification of the Terms of Use */}
          <h4 className=" mt-4">
            17. Modification of the Terms of Use
          </h4>
          <p>
            As stated earlier, we may modify these Terms of Use in our sole
            discretion at any time, with or without notice to you. Any such
            modifications will be effective upon posting to the Portal, and your
            continued use of the Portal and the Services following such posting
            constitutes your acceptance of the modified Terms. You are
            encouraged to review these Terms regularly to remain informed of any
            changes.
          </p>

          {/* Section 18 - Governing Law */}
          <h4 className=" mt-4">18. Governing Law</h4>
          <p>
            These Terms of Use shall be governed by and construed in accordance
            with the laws of the State of
            <strong> Delaware</strong>, without regard to its conflicts of laws
            principles.
          </p>

          {/* Section 19 - Dispute Resolution */}
          <h4 className=" mt-4">19. Dispute Resolution</h4>
          <p>
            Any disputes, claims, or controversies arising from or related to
            these Terms, the Portal, the Services, or your participation in the
            Program shall be addressed and resolved in three (3) phases, except
            to the extent that the mandatory laws of your country of residence
            require a different process, in which case such mandatory provisions
            shall prevail.
          </p>

          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>
              <strong>(i) Negotiation</strong>
              <br />
              The aggrieved Party shall notify the other Party in writing of the
              events or occurrences giving rise to the dispute. Within ten (10)
              days of receipt of the notice, responsible representatives of the
              Parties shall meet and, in good faith, attempt to resolve the
              dispute through direct negotiation.
            </li>
            <li className="mt-2">
              <strong>(ii) Mediation</strong>
              <br />
              If negotiations fail, the Parties shall jointly select a mediator
              and, within twenty (20) days thereafter, participate in mediation
              in New York City, New York, at a location selected by the
              mediator, unless otherwise agreed. Mediation shall conclude within
              forty-five (45) days of the initial dispute notice, unless
              extended by mutual agreement.
            </li>
            <li className="mt-2">
              <strong>(iii) Arbitration</strong>
              <br />
              If mediation fails, the matter shall be submitted to exclusive
              binding arbitration before a single arbitrator in New York City,
              New York, under the then-current Commercial Arbitration Rules of
              the American Arbitration Association. The arbitrator may award
              actual damages (excluding punitive damages), injunctive relief, or
              other equitable remedies as deemed appropriate. Judgment on the
              award may be entered in any court with jurisdiction. Each Party
              shall bear its own attorneys’ fees, and the costs of arbitration
              shall be shared equally, unless the arbitrator orders otherwise.
            </li>
          </ul>

          <p>
            For Users located in the European Union, LHG provides the following
            link to the European Commission’s Online Dispute Resolution (ODR)
            platform:{" "}
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://ec.europa.eu/consumers/odr
            </a>
            . This is provided for information purposes only and does not
            constitute LHG’s agreement to submit to any specific dispute
            resolution body, except as required by applicable law.
          </p>

          {/* Section 20 - Class Action Waiver */}
          <h4 className=" mt-4">20. Class Action Waiver</h4>
          <p>
            You agree to waive any right to participate in or initiate any class
            action, collective action, or similar proceeding against LHG, its
            parent, affiliates, subsidiaries, successors, or assigns, whether at
            law or in equity, and regardless of which Party initiates the claim.
            This waiver applies to any matter arising out of or related to these
            Terms, the performance of either Party, and/or your use of the
            Portal and the Services.
          </p>

          {/* Section 21 - Assignment */}
          <h4 className=" mt-4">21. Assignment</h4>
          <p>
            These Terms and the rights and obligations hereunder are personal to
            you and may not be assigned, transferred, or subcontracted without
            LHG’s prior written consent. Any attempted assignment without such
            consent shall be null and void. LHG may assign, transfer, or
            subcontract any of its rights or obligations under these Terms at
            its sole discretion without your consent.
          </p>
          {/* Section 22 - Miscellaneous */}
          <h4 className=" mt-4">22. Miscellaneous</h4>
          <p>
            The failure of either Party to enforce any provision of these Terms
            shall not be construed as a waiver of such provision or of the right
            to enforce it later. If any provision of these Terms is determined
            to be illegal, unenforceable, or excessively broad, that provision
            shall be modified to the minimum extent necessary to render it
            enforceable, and the remainder shall remain in full force and
            effect. Headings are for convenience only and shall not affect
            interpretation.
          </p>
          <p>
            These Terms, together with any documents, ancillary agreements and
            referenced policies, expressly incorporated by reference, constitute
            the entire agreement between you and LHG with respect to your access
            to and use of the Portal and the Services, and supersede all prior
            or contemporaneous agreements, understandings, negotiations, and
            communications, whether written or oral, relating to the subject
            matter herein.
          </p>
          <p>
            Any provisions of these Terms that by their nature should survive
            termination, including but not limited to those relating to
            intellectual property, payments, disclaimers, limitations of
            liability, indemnification, and dispute resolution, shall survive
            any termination of your Account or these Terms.
          </p>

          {/* Section 23 - Compliance with Laws; Export Controls */}
          <h4 className=" mt-4">
            23. Compliance with Laws; Export Controls
          </h4>
          <p>
            You represent and warrant that your access to and use of the Portal
            and the Services will comply with all applicable local, state,
            national, and international laws, rules, and regulations, including
            without limitation all applicable privacy, consumer protection,
            anti-money laundering, anti-corruption, and export control laws.
          </p>
          <p>
            You further acknowledge and agree that the Portal and the Services,
            and any related technology, data, and content, may be subject to the
            export control and economic sanctions laws of the United States and
            other jurisdictions, including, without limitation, the U.S. Export
            Administration Regulations (“EAR”), the U.S. International Traffic
            in Arms Regulations (“ITAR”), and the regulations administered by
            the U.S. Department of the Treasury’s Office of Foreign Assets
            Control (“OFAC”).
          </p>

          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>
              (i) In or to any country, jurisdiction, person, or entity
              prohibited by applicable law or sanctions,
            </li>
            <li>
              (ii) To anyone on any U.S. government or other applicable
              restricted party lists, or
            </li>
            <li>
              (iii) For any purpose prohibited by applicable law, including
              without limitation the development, design, manufacture, or
              production of nuclear, missile, or chemical or biological weapons.
            </li>
          </ul>

          <p>
            LHG reserves the right to restrict access to the Portal and the
            Services in any location or to any User where required by law or
            regulation or where, in its sole discretion, it determines that such
            use presents undue legal, compliance, or operational risk.
          </p>

          {/* Section 24 - Accessibility */}
          <h4 className=" mt-4">24. Accessibility</h4>
          <p>
            LHG is committed to ensuring that the Portal and the Services are
            accessible to the widest possible audience, regardless of technology
            or ability, and in compliance with applicable accessibility laws,
            including, where applicable, the Americans with Disabilities Act
            (ADA), Section 508 of the U.S. Rehabilitation Act, and the Web
            Content Accessibility Guidelines (WCAG) 2.1 Level AA, as well as
            equivalent standards in other jurisdictions.
          </p>
          <p>
            We are continually working to improve the user experience and to
            apply relevant accessibility standards. If you experience any
            difficulty accessing or using any part of the Portal or the
            Services, or if you have accessibility-related questions or
            feedback, please contact us at{" "}
            <a href="mailto:accessibility@littlehaitiglobal.com">
              accessibility@littlehaitiglobal.com
            </a>
            . We will make reasonable efforts to address your concerns and
            provide the requested information or assistance in an accessible
            format.
          </p>
          {/* Section 25 - Electronic Signatures and Communications */}
          <h4 className=" mt-4">
            25. Electronic Signatures and Communications
          </h4>
          <p>
            By creating an Account, accessing the Portal, or using the Services,
            you consent to transact with LHG electronically, including receiving
            all agreements, notices, disclosures, and other communications in
            electronic form. You acknowledge and agree that any electronic
            communications sent to you by LHG, whether by email, secure Portal
            messaging, SMS, or other electronic means, satisfy any legal
            requirement that such communications be in writing, to the fullest
            extent permitted by applicable law.
          </p>
          <p>
            You further agree that your actions in electronically selecting
            checkboxes, clicking “I Agree” or similar buttons, typing your name,
            or otherwise indicating acceptance or authorization through the
            Portal, constitute your valid and binding electronic signature, and
            that such actions shall have the same legal force and effect as a
            manual signature under the U.S. Electronic Signatures in Global and
            National Commerce Act (E-SIGN), the Uniform Electronic Transactions
            Act (UETA), and any equivalent laws in other jurisdictions.
          </p>
          <p>
            If you withdraw your consent to receive communications
            electronically, LHG may, at its sole discretion, restrict, suspend,
            or terminate your access to the Portal and the Services.
          </p>

          {/* Section 26 - Mandatory Law Carve-Out */}
          <h4 className=" mt-4">26. Mandatory Law Carve-Out</h4>
          <p>
            Nothing in these Terms shall exclude, limit, or otherwise affect any
            rights or remedies that you may have as a consumer under the
            mandatory laws of your country of residence, including, where
            applicable, the European Union Directive 93/13/EEC on unfair terms,
            the EU Consumer Rights Directive 2011/83/EU, and the United Kingdom
            Consumer Rights Act 2015.
          </p>
          <p>
            In the event of any conflict between these Terms, including but not
            limited to the Governing Law (Section 18) and Dispute Resolution
            (Section 19) provisions, and such mandatory laws, the provisions of
            the mandatory laws shall prevail. This clause ensures that these
            Terms are interpreted and applied in compliance with all
            non-excludable statutory rights in your jurisdiction.
          </p>

          {/* Section 27 - Language */}
          <h4 className=" mt-4">27. Language</h4>
          <p>
            These Terms of Use may be translated into other languages for
            convenience. In the event of any conflict or inconsistency between a
            translated version and the English version, the English version
            shall prevail and be controlling in all respects. All
            communications, notices, and dispute resolution proceedings shall be
            conducted in English unless otherwise required by applicable law or
            agreed in writing by the Parties.
          </p>
          {/* Section 28 - Some Specific Jurisdictions */}
          <h4 className=" mt-4">28. Some Specific Jurisdictions</h4>

          {/* A. California Users */}
          <h4 className="">A. California Users</h4>
          <p>
            If you are a California resident, you may have additional rights
            under the California Consumer Privacy Act as amended by the
            California Privacy Rights Act (CCPA and CPRA). These rights may
            include the right to know, access, correct, and delete certain
            personal information that LHG collects about you, as well as the
            right to opt out of certain disclosures of personal information.
            LHG’s Privacy Policies describe these rights and how to exercise
            them.
          </p>
          <p>
            Pursuant to California Civil Code Section 1789.3, you may also
            contact the Complaint Assistance Unit of the Division of Consumer
            Services of the California Department of Consumer Affairs in writing
            at
            <br />
            <strong>
              1625 North Market Boulevard, Suite N 112, Sacramento, California
              95834
            </strong>
            , or by telephone at <strong>(800) 952 5210</strong>.
          </p>

          {/* B. EU and UK Users */}
          <h4 className=" mt-3">B. EU and UK Users</h4>

          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
              
            }}
          >
            <li>
              (i) <strong>Mandatory Laws:</strong> Nothing in these Terms shall
              exclude, limit, or otherwise affect any rights you may have under
              applicable EU or UK consumer protection laws, which shall prevail
              over conflicting provisions in these Terms.
            </li>
            <li>
              (ii) <strong>Online Dispute Resolution:</strong> In accordance
              with Regulation (EU) No 524/2013, LHG provides the following link
              to the European Commission’s Online Dispute Resolution (ODR)
              platform:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://ec.europa.eu/consumers/odr
              </a>
              . This link is provided for information purposes only and does not
              constitute LHG’s agreement to submit to any specific dispute
              resolution body, except as required by applicable law.
            </li>
            <li>
              (iii) <strong>Alternative Dispute Resolution in the UK:</strong>{" "}
              If you are a UK consumer and we are unable to resolve a complaint
              through our internal complaint-handling process, we will inform
              you whether we are willing to use an alternative dispute
              resolution (ADR) provider and, if so, provide you with the details
              of an approved ADR provider.
            </li>
            <li>
              (iv) <strong>Cooling-Off Rights:</strong> If applicable law grants
              you a right to withdraw from certain contracts within a specified
              period (such as the 14-day cooling-off period under EU and UK
              consumer law), you may exercise that right in accordance with the
              instructions provided by LHG or as set out in our Privacy Policies
              or other applicable documents.
            </li>
          </ul>

          {/* Section 29 - Contact Us */}
          <h4 className=" mt-4">29. Contact Us</h4>
          <p>For questions, assistance, or complaints, contact:</p>
          <p className="mb-1">
            <strong>Little Haiti Global Inc.</strong>
          </p>
          <p className="mb-1">Attn: 9841 Washingtonian Blvd Suite 200 #1102</p>
          <p className="mb-1">Gaithersburg, MD 20878</p>
          <p>
            Email:{" "}
            <a href="mailto:support@littlehaitiglobal.com">
              support@littlehaitiglobal.com
            </a>
          </p>

          {localStorage?.getItem("code-verified") && (
            <button
              onClick={handleSubmit}
              type="submit"
              className="submit-button"
              style={{
                width: "130px",
                padding: "0.70rem",
                color: "white",
                border: "none",
                borderRadius: "4px",
                fontSize: "1rem",
                fontWeight: "600",
                cursor: "pointer",
                marginBottom: "0px",
              }}
            >
              I Agree
            </button>
          )}
        </div>
      </div>
    </>
  );
}
